import CorporateDealByMarketTile from './CorporateDealByMarketTile';

export default CorporateDealByMarketTile;
